import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { restoreVersions } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function updateProcedureVersion({
  accountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(restoreVersions(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  params: {
    Id: number;
    CID: string;
    PID: string;
    SID: string;
    Content: string;
    SnapshotTime: number | undefined;
  };
};

type TSnapshot = unknown;

function useRestoreVersions(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId }: TVariables) => {
    const { Id } = params;
    const restoredVersion = await updateProcedureVersion({
      accountId,
      params,
    });
    if (restoredVersion.Data) {
      queryClient.invalidateQueries(['get_procedure_version_history'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_procedure', accountId, Id], {
        refetchInactive: true,
      });
    } else if (restoredVersion.Errors) throw restoredVersion;
    return restoredVersion;
  });
}

export { useRestoreVersions };
